import { useState, useEffect } from "react";
import { Check, Loader2 } from "lucide-react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "./ui/input-otp";
import { Button } from "./ui/button";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { setAccessToken, setRefreshToken } from "../storage/storage";

export function OTPVerification() {
  const location = useLocation();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleVerify = () => {
    if (otp.length !== 4) return;

    setIsVerifying(true);

    axios
      .post(`${BASE_URL}/api/verify-otp/`, {
        email: location.state.email,
        otp: otp,
      })
      .then((res) => {
        setIsVerifying(false);
        setIsSuccess(true);

        setAccessToken(res.data.access);
        setRefreshToken(res.data.refresh);
        
        setTimeout(() => {
          navigate("/");
        }, 1000);
      })
      .catch((e) => {
        setIsSuccess(false);
        setOtp("");
        setIsVerifying(false);
      });
  };

  const handleResend = () => {
    axios
      .post(`${BASE_URL}/api/resend-otp/`, {
        email: location.state.email,
      })
      .then((res) => {
        setTimeLeft(30);
      });
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2 text-center">
        <h1 className="font-semibold text-emerald-600 text-3xl">
          Verification Code
        </h1>
        <p className="mx-auto max-w-xs text-gray-600">
          We've sent a 4-digit verification code to your email
        </p>
      </div>

      <div className="space-y-6">
        <div className="space-y-4">
          <div className="flex justify-center">
            <InputOTP maxLength={6} value={otp} onChange={setOtp}>
              <InputOTPGroup className="flex gap-2">
                <InputOTPSlot
                  index={0}
                  className="bg-gray-100 border-0 rounded-md w-12 h-12"
                />
                <InputOTPSlot
                  index={1}
                  className="bg-gray-100 border-0 rounded-md w-12 h-12"
                />
                <InputOTPSlot
                  index={2}
                  className="bg-gray-100 border-0 rounded-md w-12 h-12"
                />
                <InputOTPSlot
                  index={3}
                  className="bg-gray-100 border-0 rounded-md w-12 h-12"
                />
              </InputOTPGroup>
            </InputOTP>
          </div>
        </div>

        <Button
          onClick={handleVerify}
          disabled={otp.length !== 4 || isVerifying || isSuccess}
          className="bg-emerald-600 hover:bg-emerald-700 rounded-full w-full h-12 text-white"
        >
          {isVerifying && <Loader2 className="mr-2 w-4 h-4 animate-spin" />}
          {isSuccess && <Check className="mr-2 w-4 h-4" />}
          {isVerifying ? "Verifying..." : isSuccess ? "Verified!" : "Verify"}
        </Button>

        <div className="text-sm text-center">
          {timeLeft > 0 ? (
            <p className="text-gray-500">
              Resend code in <span className="font-medium">{timeLeft}s</span>
            </p>
          ) : (
            <button
              onClick={handleResend}
              className="font-medium text-emerald-600 text-sm hover:underline"
            >
              Resend Code
            </button>
          )}
        </div>
      </div>

      <div className="text-center">
        <button
          onClick={() => navigate("/login")}
          className="font-medium text-emerald-600 text-sm hover:underline"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}
